import { SFormUploadImage } from "shj-components";
import { Cascader, Col, Form, Input, InputNumber, message, Row, Spin, Switch } from "antd";
import { addDealkingTalkOrderHomeConf, editDealkingTalkOrderHomeConf, getHomeConfigTree } from "@/services/talkOrder.ts";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { baseURL } from "@/api";
import { findAllPath, useFileUrlPrefix } from "shj-utils";
import { covertResourceOptions } from "@/utils/common";
import { AcceptType } from "shj-components/dist/es/SFormUploadImage";

const { TextArea } = Input

const AddOrEditHomeConfigDom: React.FC<any> = forwardRef(({ record, reload, onClose, ...rest }, ref) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [homeConfigTree, setHomeConfigTree] = useState<any>([]);

  const uploadFileUrl = baseURL + `file-web/file/upload`;
  const [imagePrefix] = useFileUrlPrefix();

  useEffect(() => {
    getOptions().then((resp) => {
      const covertResourceList = covertResourceOptions(resp[0] || [], {
        topNode: {
          label: '顶级节点',
          value: record?.topPid,
        }
      })
      setHomeConfigTree(covertResourceList)
      if (record?.id) {
        const path = findAllPath({ value: record.pid }, covertResourceList)
        if (record?.iconUrl) {
          const obj: any = {}
          obj.response = {}
          obj.response.data = {}
          obj.response.data.url = record?.iconUrl
          const nameArr = record?.iconUrl?.split('/')
          obj.response.data.name = nameArr?.[nameArr?.length - 1]
          setFileList([
            {
              uid: '1',
              name: nameArr?.[nameArr?.length - 1],
              url: record?.iconUrl?.startsWith('http') ? record?.iconUrl : (imagePrefix + record?.iconUrl),
              status: 'done',
              ...obj
            }
          ])
        }
        form?.setFieldsValue({ ...record, pid: path.map(d => d.value) })
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [])

  // 获取父级资源
  const getOptions = () => {
    return Promise.all([
      getHomeConfigTree({ pid: record?.topPid }),
    ])
  }

  const onFinish = () => {
    return new Promise((resolve, reject) => {
      if (loading) { reject({}); return false };
      setLoading(true);
      form.validateFields().then(values => {
        console.log('onFinish>>>', values);
        try {
          const newValues = { ...values };
          newValues.iconUrl = values?.iconUrl?.[0]?.response?.data?.filePath;

          if (Array.isArray(values.pid)) {
            newValues.pid = values.pid[values.pid.length - 1]
          }

          let apiUrl = addDealkingTalkOrderHomeConf;
          if (record?.id) {
            newValues.id = record.id;
            apiUrl = editDealkingTalkOrderHomeConf;
          }
          // console.log('newValues-----------',newValues)
          // return
          apiUrl(newValues).then((res: any) => {
            message.success('操作成功');
            setLoading(false);
            resolve({});
          }).catch(() => {
            setLoading(false);
            reject({ msg: '操作失败' });
          })

        } catch (err) {
          setLoading(false);
          reject(err);
        }
      }).catch(err => {
        setLoading(false);
        reject(err);
      })
    })
  };

  useImperativeHandle(
    ref,
    () => ({
      form,
      onFinish
    }),
    [form, onFinish],
  );

  return (<Spin spinning={loading}>
    <Form form={form} layout="vertical" autoComplete="off">
      <Row gutter={12}>
        <Col span={24}>
          <Form.Item label="菜单名称" name="name" rules={[{ required: true, message: '不能为空' }]}>
            <Input placeholder='请输入菜单名称' maxLength={10} />
          </Form.Item>
        </Col>
        {/* <Form.Item label="菜单别名" name="alias" >
          <Input placeholder='请输入菜单别名' maxLength={10} />
        </Form.Item> */}
        <Col span={24}>
          <Form.Item label="菜单编码" name="code" rules={[{ required: true, message: '不能为空' }]}>
            <Input placeholder='请输入菜单编码' maxLength={50} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="所属父级菜单" name="pid" rules={[{ required: true, message: '不能为空' }]}>
            <Cascader
              placeholder="请选择父级菜单"
              allowClear
              expandTrigger="hover"
              changeOnSelect
              options={homeConfigTree}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="排序" name="sortNumber" rules={[{ required: true, message: '不能为空' }]}>
            <InputNumber style={{ width: '100%' }} min={0} max={9999}/>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="菜单地址" name="routeUrl">
            <Input placeholder='请输入菜单地址' />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="是否启用" name="status" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="菜单图片" name="iconUrl">
            <SFormUploadImage
              maxCount={1}
              url={uploadFileUrl}
              limit={1}
              accept={AcceptType.picture}
              fileList={fileList}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="备注" name="remark">
            <TextArea maxLength={300} placeholder='请输入备注' rows={3} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  </Spin>)
})
export default AddOrEditHomeConfigDom;